import React, { useEffect } from 'react';
import { NoAuthPageTemplate } from '../../layout/NoAuthPageTemplate/NoAuthPageTemplate';
import { SplashScreen } from '@capacitor/splash-screen';

import { Capacitor } from '@capacitor/core';
import { ANDROID_APP_URL } from '../../config/mobileApps';
import { IOS_APP_URL } from '../../config/mobileApps';
import { Button } from 'primereact/button';

const isAndroid = Capacitor.getPlatform() === 'android';
const isIOS = Capacitor.getPlatform() === 'ios';

const getAppUrl = () => {
  if (isAndroid) {
    return ANDROID_APP_URL;
  }
  if (isIOS) {
    return IOS_APP_URL;
  }
  return ANDROID_APP_URL;
};

export const UpdateApp = () => {
  const appUrl = getAppUrl();

  // The session is kept on this page and the user is not loaded, so App does not hide the splash screen.
  useEffect(() => {
    SplashScreen.hide();
  }, []);

  return (
    <NoAuthPageTemplate icon='pi pi-exclamation-triangle' color='error'>
      <h2>La aplicación no está actualizada</h2>
      <p>Por favor, actualiza la aplicación para continuar</p>
      <Button label='Actualizar aplicación' onClick={() => window.open(appUrl, '_blank')} />
      <p>Una vez actualizada, vuelve a abrir la aplicación.</p>
      {/* A full page load, so the session is read again: a router navigation keeps the user unloaded. */}
      <Button label='Volver al inicio' icon='pi pi-arrow-left' link onClick={() => window.location.assign('/')} />
    </NoAuthPageTemplate>
  );
};
